import { BaseMapAutoZoomService } from '@/modules/ta/legacy/widget/services/types/BaseMapAutoZoomService';
import { GEOMETRY } from '@/modules/core/legacy/charts/am5/geo/geo.charts.constants';

export class HeatMapAutoZoomService extends BaseMapAutoZoomService {
  constructor(topPercent = 100) {
    super(topPercent);
  }

  getTopPercent(parsedData, field) {
    const sorted = [...parsedData].sort((a, b) => b[field] - a[field]);
    const count = Math.ceil((this.topPercent / 100) * sorted.length);
    return sorted.slice(0, count);
  }

  computeBounds(series, rawData, isState) {
    let minLat = 90,
      maxLat = -90,
      minLon = 180,
      maxLon = -180;

    rawData.forEach((row) => {
      let dataItem = series.getDataItemById(row.geocode0?.toUpperCase());
      if (isState) {
        dataItem = series.getDataItemById(row.geocode1?.toUpperCase());
      }
      const geometry = dataItem?.get(GEOMETRY);
      if (geometry) {
        const coords = geometry.coordinates.flat(Infinity);
        for (let i = 0; i < coords.length; i += 2) {
          const lon = coords[i];
          const lat = coords[i + 1];
          if (lat < minLat) minLat = lat;
          if (lat > maxLat) maxLat = lat;
          if (lon < minLon) minLon = lon;
          if (lon > maxLon) maxLon = lon;
        }
      }
    });

    return {
      north: maxLat,
      south: minLat,
      east: maxLon,
      west: minLon,
    };
  }

  // Main method: auto-zoom based on top % values
  getBounds(series, field, rawData, isState) {
    if (rawData.length === 0) return [];
    let topPoints = this.getTopPercent(rawData, field);
    if (topPoints.length === 0) return [];

    let computedBounds = this.computeBounds(series, topPoints, isState);
    return this.normalizeBounds(computedBounds);
  }
}
